export default __webpack_public_path__ + "static/media/eldoctor.efe9d7dc.png";